<template>
  <div>
    <div v-if="bill.file">
      <strong>File:&#160;</strong>
      <FileGql :file="bill.file" />
    </div>
    <p style="color: red" v-if="bill.frozen">
      FROZEN - no more changes allowed. To edit clone bill on file.
    </p>
    <div v-if="bill.related.length > 0">
      <strong>Related bills:</strong>
      <span v-for="relatedBill in bill.related" :key="relatedBill.id">
        <span>&#160;</span>
        <router-link :to="{ name: 'bill', params: { id: relatedBill.id } }">{{
          relatedBill.id
        }}</router-link>
      </span>
    </div>
    <p v-if="$keycloak.hasRealmRole('billadmin')">
      <a @click="$emit('toggleLocked')">Locked</a>
      <span>:</span>
      <span :class="booleanStrongStyle(bill.locked)">{{
        booleanConverter(bill.locked)
      }}</span>
    </p>
    <p>
      <template v-if="headerStatus != 1">
        <a @click="headerStatus = 1" v-if="!editDisabled">Date</a>
        <span v-if="editDisabled">Date</span>
        <span>:</span>
        <span v-if="customdate">{{ customdate | formatDate }}</span>
      </template>
      <template v-if="headerStatus == 1">
        <div class="ajaxForm">
          <h2>Change date of bill</h2>
          <p>
            Override the date of the bill with a custom date. The custom date
            will be used to fetch the details from the address book. If the
            details do not update you may need to update the time component of
            the created date to fetch new results where bill was created on same
            day.
          </p>
          <table>
            <tr>
              <th>Time created</th>
              <td>
                {{ bill.timestamp | formatDateTime }}
                <a @click="updateBillAdjustedTime">&lt;update time</a>
              </td>
            </tr>
          </table>
          <v-date-picker v-model="customdatecopy" />
          <div>
            <v-btn @click="updateBillDate">Update</v-btn>
            <v-btn @click="headerStatus = 0" v-if="!editDisabled">Cancel</v-btn>
          </div>
        </div>
      </template>
    </p>
    <p>
      <template v-if="headerStatus != 2">
        <span style="white-space: pre-wrap" v-html="address" />
        <a @click="headerStatus = 2" v-if="!editDisabled">change</a>
      </template>
      <template v-if="headerStatus == 2">
        <div class="ajaxForm">
          <p>
            Change the address to a custom address where not in address book
          </p>
          <v-textarea label="Address" v-model="addresscopy" />
          <!-- <b:inputTextarea label="#{msg.bill45}" id="address" value="#{billBean.bill.customaddress}" /> -->
          <v-btn @click="updateBillAddressWrapper" color="info">
            <v-icon>save</v-icon>update
          </v-btn>
          <v-btn @click="headerStatus = 0" v-if="!editDisabled">Cancel</v-btn>
          <v-btn @click="clearBillAddressWrapper" color="info">clear</v-btn>
        </div>
      </template>
    </p>
    <div>
      <a @click="$emit('toggleSpecial')" v-if="!editDisabled"
        >Special delivery</a
      >
      <span v-if="editDisabled">Special delivery</span>
      <span>:</span>
      <span :class="booleanStrongStyle(bill.special)">{{
        booleanConverter(bill.special)
      }}</span>
    </div>
  </div>
</template>

<script>
import FileGql from "@/components/link/FileGql";
import { booleanStrongStyle, booleanConverter } from "@/util/helpers";
export default {
  name: "Header",
  components: {
    FileGql
  },
  props: ["editDisabled", "bill", "address", "customdate"],
  data() {
    return {
      headerStatus: 0,
      customdatecopy: null,
      addresscopy: null
    };
  },
  methods: {
    booleanStrongStyle,
    booleanConverter,
    updateBillAddressWrapper() {
      this.$emit("updateBillAddress", {
        customaddress: this.addresscopy
      });
      this.headerStatus = 0;
    },
    clearBillAddressWrapper() {
      this.$emit("updateBillAddress", {
        customaddress: null
      });
      this.headerStatus = 0;
    },
    updateBillAdjustedTime() {
      this.$emit("updateBillAdjustedTime");
      this.headerStatus = 0;
    },
    updateBillDate() {
      this.$emit("updateBillDate", { customdate: this.customdatecopy });
      this.headerStatus = 0;
    }
  },
  watch: {
    customdate: {
      immediate: true,
      handler() {
        this.customdatecopy = this.customdate
          ? this.customdate.substr(0, 10)
          : undefined;
      }
    },
    address: {
      immediate: true,
      handler() {
        this.addresscopy = this.address ? this.address : undefined;
      }
    }
  }
};
</script>

<style>
</style>
